<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-field
          :label="$t('D004','身份证')"
          :placeholder="$t('peyin','请输入身份证号码')"
          v-model="idNumber"
          input-align="left"
          clearable
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'
import { validators } from 'Utils/valid'

export default {
  name: 'EditIdNumber',
  mixins: [mixin],
  data() {
    return {
      idNumber: ''
    }
  },
  created () {
    this.idNumber = this.empInfo.idNumber
  },
  methods: {
    complie () {
      let valider = validators['is-idCard'](this.idNumber)
      if (!valider.valid) {
        this.$toast(valider.msg)
        return
      }
      
      this.empInfo.idNumber = this.idNumber
      this.save()
    }
  }
}
</script>